import Vue from 'vue';
import VueApollo from 'vue-apollo';
import { ApolloClient } from 'apollo-client';
import { HttpLink } from 'apollo-link-http';
import { InMemoryCache } from 'apollo-cache-inmemory';
import { split } from 'apollo-link';
import { WebSocketLink } from 'apollo-link-ws';
import { getMainDefinition } from 'apollo-utilities';
import store from './store/index';
import { API_GRAPHQL_HOST, API_WS_HOST } from './utils/constants/api';

const headers = () => {
  let obj = {};
  if (store.state?.auth?.publicAccess) {
    obj['act-public-key'] = store.state?.auth?.publicAccess;
  } else if (window.location.pathname.match(/\/public\/([^/]+)/)) {
    obj['act-public-key'] = window.location.pathname.match(/\/public\/([^/]+)/)[1];
  }
  if (store.state?.auth?.token) obj.Authorization = `Token ${store.state?.auth?.token}`;
  return obj;
};

const httpLink = new HttpLink({
  // You should use an absolute URL here
  uri: `${API_GRAPHQL_HOST}/v1/graphql`,
  headers: headers(),
});

// Create the subscription websocket link
const wsLink = new WebSocketLink({
  uri: `${API_WS_HOST}/v1/graphql`,
  options: {
    reconnect: true,
    lazy: true, // подключается только тогда, когда потребуется
    connectionParams: { headers: headers() },
  },
});

// using the ability to split links, you can send data to each link
// depending on what kind of operation is being sent
const link = split(
  // split based on operation type
  ({ query }) => {
    const definition = getMainDefinition(query);
    return definition.kind === 'OperationDefinition' && definition.operation === 'subscription';
  },
  wsLink,
  httpLink
);

// Create the apollo client
const apolloClient = new ApolloClient({
  link,
  cache: new InMemoryCache(),
  connectToDevTools: true,
  defaultOptions: {
    query: {
      fetchPolicy: 'no-cache',
    },
  },
});

// Install the vue plugin like before
Vue.use(VueApollo);

const apolloProvider = new VueApollo({
  defaultClient: apolloClient,
});

export default apolloProvider;
